import * as types from './mutation-types'

export default {
  [types.SET_ACCESS_TOKEN]: (state, obj) => {
    state.access_token = obj.access_token
  },
  [types.SET_REFRESH_TOKEN]: (state, obj) => {
    state.refresh_token = obj.refresh_token
  },
  [types.REMOVE_REFRESH_TOKEN]: (state) => {
    state.access_token = null
  },
  [types.REMOVE_ACCESS_TOKEN]: (state) => {
    state.refresh_token = null
  },
  [types.REDIRECT]: (state,obj) => {
    state.redirect = obj.redirect
  }
}



// WEBPACK FOOTER //
// ./src/features/Auth/store/mutations.js